export enum ComponentId {
  ARE_PREVIOUS_DAMAGE_PRESENT = "previousDamage",
  PREVIOUS_DAMAGE_DESCRIPTION = "previousDamageDescription",
  ARE_OTHER_DAMAGES_PRESENT = "otherDamages",
  OTHER_DAMAGES_DESCRIPTION = "otherDamagesDescription",
  PROPERTY_PLACE = "propertyPlace",
}
